export default __webpack_public_path__ + "static/media/AppIcon.bf735c23.svg";